import { useEffect, useRef, useState } from "react";

export function FilePicker({
  label,
  file,
  onChange,
}: {
  label: string;
  file: File | null;
  onChange: (file: File | null) => void;
}) {
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!file || !file.type.startsWith("image/")) return;
    const url = URL.createObjectURL(file);
    // Syncing with the external object-URL lifecycle is exactly what this effect is for.
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setPreviewUrl(url);
    return () => {
      URL.revokeObjectURL(url);
      setPreviewUrl(null);
    };
  }, [file]);

  return (
    <div className="vform-field">
      <span className="vform-label">{label}</span>
      <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
        <button type="button" className="file-picker-btn" onClick={() => inputRef.current?.click()}>
          {file ? "Change file" : "Choose file"}
        </button>
        <span className="file-picker-name">{file ? file.name : "No file chosen"}</span>
        <input
          ref={inputRef}
          type="file"
          accept="image/jpeg,image/png,image/webp,application/pdf"
          onChange={(event) => onChange(event.target.files?.[0] ?? null)}
          style={{ display: "none" }}
        />
      </div>
      {previewUrl ? <img src={previewUrl} alt={`${label} preview`} className="file-preview" /> : null}
    </div>
  );
}
